<div *ngIf="loadingService.loading()" class="loading-overlay">
    <div class="loading-spinner"></div>
  </div>